import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../theme/style-helpers';
import ArrowRightWhite from '../../assets/icons/ArrowRightWhite.svg';
import ArrowRightOrange from '../../assets/icons/ArrowRightOrange.svg';
import ArrowRightBlack from '../../assets/icons/ArrowRightBlack.svg';
import ArrowLeftOrange from '../../assets/icons/ArrowLeftOrange.svg';
import Error from '../../assets/icons/Error.svg';

export const InputStrategy = styled.div`
    width: 100%;   
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-bottom: 58px;
    flex-wrap: wrap;
`;

export const PrimaryButton = styled.button`
    background-color: ${colors.DARK_GREY};
    font-style: normal;
    position: relative;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: normal;
    text-align: center;
    color: ${colors.COOL_GREY};
    padding: 16px 56px;
    border: 1px solid ${colors.DARK_GREY};
    border-radius: 3px;
    margin-left: 0;
    margin-bottom: 10px;
    width: 100%;
    cursor: pointer;
    order: 0;
    float: none;

    &.min-width {
        min-width: 300px;
    }

    &.max-width-200 {
        max-width: 200px;
    }

    ${MediaQuery.medium`
        width: auto;
        margin-bottom: 0;
        margin-top:24px;
        order: 1;

        &.float-right {
            float: right;
        }
    `}

    .icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 17px;
        margin: 0;
        height: 24px;
        width: 24px;
        background: url(${ArrowRightWhite});
        background-size: cover;
    }

    &.submit, &.active {
        background-color: ${colors.BLACK};

        .icon {
            background: url(${ArrowRightOrange});
        }

        &:hover {
            background-color: ${colors.BRAND_ORANGE};
            color: ${colors.BLACK};
            border-color: ${colors.BRAND_ORANGE};

            .icon {
                background: url(${ArrowRightBlack});
            }
        }
    }
`;

export const SecondaryButton = styled.button`
    background-color: ${colors.WHITE};
    position: relative;
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: normal;
    text-align: center;
    color: ${colors.BLACK};
    padding: 16px 56px;
    border: 1px solid ${colors.BLACK};
    border-radius: 3px;
    margin-left: 0;
    width: 100%;
    order: 1;
    cursor: pointer;

    &.min-width {
        min-width: 300px;
    }

    ${MediaQuery.medium`
        width: auto;        
        order: 0;
    `}

    .icon-left {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 17px;
        margin: 0;
        height: 24px;
        width: 24px;
        background: url(${ArrowLeftOrange});
        background-size: cover;
    }

    .icon-right {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 17px;
        margin: 0;
        height: 24px;
        width: 24px;
        background: url(${ArrowRightOrange});
        background-size: cover;
    }

    &.no-border {
        border: none;
    }

    &:hover {
        border-color: ${colors.BRAND_ORANGE};
    }

    &.hidden {
        display: none;
    }
`;

export const Icon = styled.img`
    margin-right: 10px;

    &.right {
        margin-right: 0;
        margin-left: 10px;
    }
`;

export const ErrorText = styled.p`
    font-weight: 700;
    font-style: normal;
    font-weight: 500;
    font-size: 1.6rem;
    color: ${colors.ERROR};
    margin: 20px 0;
`;

export const ExpandButton = styled.button`
    width: 100%;
    background-color: transparent;
    border: none;
    text-align: center;

    &.open {
        >img {
            transform:rotate(180deg);
        }
    }
`;

export const Container = styled.div`
    padding: 32px 0;
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 32px;
`;

export const PageTitle = styled.h2`
    font-weight: 500;
    font-size: 28px;
    line-height: 130%;
    color: ${colors.BLACK};
    margin: 0;
`;

export const TabsContainer = styled.div`
    width: 100%;
    display: flex;
    gap: 12px;
    border-bottom: 1px solid #D9D9D6;
`;

export const TabItem = styled.div`
    padding: 0 12px 16px;
    border-bottom: 2px solid ${({ isActive }) => (isActive ? colors.BRAND_ORANGE : 'transparent')};
    font-weight: 600;
    font-size: 18px;
    line-height: 150%;
    color: ${({ isActive }) => (isActive ? colors.BRAND_ORANGE : colors.BLACK)};
    cursor: pointer;

    &:hover {
        color: ${colors.BRAND_ORANGE};
        border-color: ${colors.BRAND_ORANGE};
    }
`;

export const FormContainer = styled.form`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 32px;
`;

export const CheckboxContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 20px;
    width: max-content;
`;

export const RadioButtonsContainer = styled.div`
    padding-left: 20px;
    display: flex;
    gap: 32px;
`;

export const NumbersInputWrapper = styled.div`
    width: 100%;
    background-color: #F9F9F9;
    padding: 32px 20px;
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 32px;

    ${MediaQuery.medium(css`
        padding: 48px;
    `)};

    ${MediaQuery.xLarge(css`
        padding: 48px 112px;
    `)}
`;

export const NumbersInputInstructions = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-auto-rows: max-content;
    row-gap: 8px;
`;

export const NumbersInputInstructionsTitle = styled.h3`
    margin: 0;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: ${colors.BLACK};
`;

export const NumbersInputInstructionsInfo = styled.p`
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: ${colors.BLACK};
`;

export const InputsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;

    ${MediaQuery.medium(css`
        display: grid;
        grid-template-columns: auto max-content;
        column-gap: 12px;
    `)}
`;

export const SubmitButtonContainer = styled.div`
    width: 100%;
    height: 58px;
    display: flex;
`;

export const ZipCodeInputContainer = styled.div`
    width: 100%;

    ${MediaQuery.medium(css`
        width: 215px;
    `)}
`;

export const NoResultsDisplay = styled.div`
    display: flex;
    background-color: #FDF3F3;
    padding: 10px;
    width: fit-content;
    gap: 10px;
    align-content: center;
`;

export const NoResultsText = styled.p`
    font-weight:500;
    font-style: normal;
    font-size: 14px;
    color:  ${colors.BLACK};
    margin: 10px 0;
`;

export const ErrorIcon = styled.img.attrs(() => ({ src: Error }))`
    width: 34px;
    height: 34px;
    align-self: center;
`;
